import { AnimatePresence, motion } from "framer-motion";
import React, { LegacyRef, useRef, useState } from "react";
import { ITabSetCategory } from "../../interfaces/ITabSetCategory";
import BrowserService from "../../utilities/browserService";
import Icon from "../icon/icon";
import { variantsReverse } from "../navMenu/framerMotionSlideVariants";
import CategoryButton from "./categoryButton";
import "./categorySlider.scss";
import { ICategorySliderProps } from "./categorySlider";

function CategorySliderClient(props: ICategorySliderProps) {
  const [displayLeftArrow, setDisplayLeftArrow] = useState(false);
  const [displayRightArrow, setDisplayRightArrow] = useState(true);
  const slider = useRef<HTMLDivElement>();
  const [legacyBrowser] = useState(BrowserService.isLegacyBrowser());

  const showCategorySlider = (
    element: React.MutableRefObject<HTMLDivElement | undefined>
  ) => {
    if (element && element.current) {
      if (
        element.current.scrollWidth >
        (element.current.clientWidth || element.current.offsetWidth)
      ) {
        return true;
      }
    }
    return false;
  };

  const modernBrowserArrow = () => {
    return (
      <AnimatePresence>
        {showCategorySlider(slider) && (displayRightArrow || displayLeftArrow) && (
          <motion.button
            className="scroll-arrow right"
            key="right_arrow"
            initial="closed"
            animate="open"
            exit="closed"
            variants={variantsReverse(0.1)}
            onClick={() => {
              if (slider.current) {
                slider.current.scroll({
                  top: slider.current.scrollTop,
                  left: displayLeftArrow
                    ? 0
                    : Math.min(
                        slider.current.scrollWidth,
                        slider.current.scrollLeft + slider.current.offsetWidth
                      ),
                  behavior: "smooth",
                });
              }
            }}
          >
            <Icon>{displayLeftArrow ? "chevron_left" : "chevron_right"}</Icon>
          </motion.button>
        )}
      </AnimatePresence>
    );
  };

  const legacyBrowserArrow = () => {
    return (
      <React.Fragment>
        {showCategorySlider(slider) && (
          <button
            className="scroll-arrow right"
            onClick={() => {
              if (slider.current) {
                slider.current.scroll({
                  top: slider.current.scrollTop,
                  left: displayLeftArrow
                    ? 0
                    : Math.min(
                        slider.current.scrollWidth,
                        slider.current.scrollLeft + slider.current.offsetWidth
                      ),
                  behavior: "smooth",
                });
              }
            }}
          >
            <Icon>{displayLeftArrow ? "chevron_left" : "chevron_right"}</Icon>
          </button>
        )}
      </React.Fragment>
    );
  };

  return (
    <div className="category-slider">
      <div
        className="category-slider-child"
        ref={slider as LegacyRef<HTMLDivElement>}
        onScroll={(event) => {
          if (slider.current) {
            const element = event.target as HTMLDivElement;
            const showRight =
              element.scrollWidth > element.offsetWidth &&
              //xxxxx.clientWidth - xxxxx.scrollWidth + xxxxx.scrollLeft
              slider.current.clientWidth -
                slider.current.scrollWidth +
                slider.current.scrollLeft <
                -30;

            setDisplayRightArrow(showRight);
            setDisplayLeftArrow(
              element.scrollWidth > element.offsetWidth && !showRight
            );
          }
        }}
      >
        {legacyBrowser ? legacyBrowserArrow() : modernBrowserArrow()}
        {props.categories &&
          props.categories.map((category, index) => {
            return (
              <CategoryButton
                key={index}
                selected={
                  props.selectedCategory &&
                  props.selectedCategory.name === category.name
                }
                hoverable={
                  props.hoveredCategory &&
                  props.hoveredCategory.name === category.name
                }
                category={category}
                onMouseEnter={props.onMouseEnter}
                onMouseLeave={props.onMouseLeave}
              />
            );
          })}
        <span style={{ marginRight: 44 }}></span>
      </div>
    </div>
  );
}

export default CategorySliderClient;
